import { Component } from '@angular/core';
import { ToasterServiceService } from '../../service/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { LocalStorageService } from '../../service/local-storage.service';
import { ApiUrls } from '../../apiRouts';
import { Location } from '@angular/common';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';

@Component({
  selector: 'app-menunal-invitation',
  templateUrl: './menunal-invitation.component.html',
  styleUrl: './menunal-invitation.component.scss'
})
export class MenunalInvitationComponent {
  getInvitedMemberListMain: any;
  getInvitedMemberList: any
  subEventId: any;
  getPresentMemberMain: any;
  getPresentMember: any
  userTypeId: any;
  user_id: any;
  selectedTabIndex: number = 0;
  dateFlag: any = false;
  constructor(
    private toasterService: ToasterServiceService,
    private dialog: MatDialog,
    private location: Location,
    private route: ActivatedRoute,
    private mainService: MainService,
    private router: Router,
    private localStorageService: LocalStorageService) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.user_id = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });

  }

  ngOnInit() {
    this.selectedTabIndex == 0 ? this.getSubEventInvitedMemberList() : this.getSubEventPresentMember();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  onTabChanged(event: number) {
    this.selectedTabIndex == 0 ? this.getSubEventInvitedMemberList() : this.getSubEventPresentMember();
  }

  getSubEventInvitedMemberList() {
    this.mainService.getApi(ApiUrls.getSubEventInvitedMember + this.subEventId).subscribe(res => {
      if (res.status == 1) {
        if (this.userTypeId == 1) {
          this.getInvitedMemberListMain = res.sub_event_member;
          this.getInvitedMemberList = res.sub_event_member
        } else {
          this.getInvitedMemberListMain = res.sub_event_member.filter((x: any) => x.user_id == this.user_id);;
          this.getInvitedMemberList = res.sub_event_member.filter((x: any) => x.user_id == this.user_id);
        }
      }
    })
  }

  getSubEventPresentMember() {
    this.mainService.getApi(ApiUrls.presentMember + this.subEventId).subscribe(res => {
      if (res.status == 1) {
        this.getPresentMember = res.event_attendance
        // this.getPresentMemberMain = res.event_attendance.filter((x:any) => x.sub_event_id == this.subEventId);
        // this.getPresentMember =res.event_attendance.filter((x:any) => x.sub_event_id == this.subEventId);
      }
    })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getSubEventInvitedMemberList();
      this.getSubEventPresentMember();
      return;
    }
    if (this.selectedTabIndex == 0) {
      this.getInvitedMemberList = this.getInvitedMemberListMain.filter((data: any) => {
        return data.member_name.toLowerCase().includes(filterValue) ||
          data.contact_no.includes(filterValue);
      });
    } else {
      this.getPresentMember = this.getPresentMemberMain.filter((data: any) => {
        return data.member_name.toLowerCase().includes(filterValue) ||
          data.contact_no.includes(filterValue);
      });
    }
  }

  goToSendInvitation() {
    if (this.dateFlag != 'true') {
      this.router.navigate(["/send-invitation/" + this.subEventId]);
    } else {
      this.toasterService.toastError('આ કાર્યક્રમ સમાપ્ત થઈ ગયો છે')
    }
  }

  showQr(id: any) {
    if (this.dateFlag != 'true') {
      const dialogRef = this.dialog.open(ConfirmDialog, {
        data: {
          page: 'showQr',
          sub_event_member_id: id
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == 1) {

        }
      });
    } else {
      this.toasterService.toastError('આ કાર્યક્રમ સમાપ્ત થઈ ગયો છે')
    }
  }

  CheckActive(id: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'manualInviteMember'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.onCodeResult(id);
      }
    });
  }

  onCodeResult(data: any) {
    var data: any = {
      event_attendance_id: 0,
      created_by: this.user_id,
      attendance_time: '',
      sub_event_member_id: Number(data.user_id),
      sub_event_id: Number(data.sub_event_id),
      Action: 'INSERT'
    }
    this.mainService.postApi(ApiUrls.attendanceMember, data, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}